import { React, useState, useEffect } from 'react'
import logo from '../images/LOGO_SHEN_v2-3.png'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAngleDown } from '@fortawesome/free-solid-svg-icons'
import { useLang } from "./Provider/LanguageProvider";


function Navbar() {
  const { language } = useLang();
  const [currentPage, SetCurrentPage] = useState(window.location.pathname);

  useEffect(() => {
    SetCurrentPage(window.location.pathname);
  }, [])

  const handleMouseOverMarques = () => {
    document.getElementById('marques').style.display = 'flex';
  }
  const handleMouseLeaveMarques = () => {
    document.getElementById('marques').style.display = 'none';
  }
  const handleMouseOverEntreprise = () => {
    document.getElementById('entreprise').style.display = 'flex';
  }
  const handleMouseLeaveEntreprise = () => {
    document.getElementById('entreprise').style.display = 'none';
  }


  return (
    <div id='navbar'>
      <div className='container'>
        <a href='/' className='logo-cont'>
          <img src={logo} alt="Shenimed logo" />
        </a>
        <div className='menu'>
          <ul className='menu-list'>
            <li className={currentPage === '/' ? 'current-page item' : 'item'}>
              <a href='/' className='nav-link'>{language === 'fr' ? 'ACCUEIL' : 'HOME'}</a>
            </li>
            <li className={currentPage === '/notrentreprise' ? 'current-page item' : 'item'} onMouseLeave={handleMouseLeaveEntreprise}>
              <a href='/notrentreprise' className='nav-link' onMouseOver={handleMouseOverEntreprise} >{language === 'fr' ? 'NOTRE ENTREPRISE' : 'OUR COMPANY'} <span className='down-arrow'><FontAwesomeIcon icon={faAngleDown} /></span></a>
              <ul className='dropdown-menu' id='entreprise'>
                <li><a href='/notrentreprise#notrehistoire' className='sub-item sub-link'>{language === 'fr' ? 'Notre Histoire' : 'Our Story'} </a></li>
                <li><a href='/notrentreprise#mission' className='sub-item sub-link'>{language === 'fr' ? 'Vision, Mission & Valeurs' : 'Vision, Mission & Values'}</a></li>
                <li><a href='/notrentreprise#defis' className='sub-item sub-link'>{language === 'fr' ? 'Défis et Opportunités' : 'Challenges & Opportunities'}</a></li>
              </ul>
            </li>
            <li className={currentPage === '/nosmarques' ? 'current-page item' : 'item'} onMouseLeave={handleMouseLeaveMarques}>
              <a href='/nosmarques' className='nav-link' onMouseOver={handleMouseOverMarques} >{language === 'fr' ? 'NOS MARQUES' : 'OUR BRANDS'}<span className='down-arrow'><FontAwesomeIcon icon={faAngleDown} /></span></a>
              <ul className='dropdown-menu' id='marques'>
                <li><a href='/nosmarques#Portsman' className='sub-item sub-link'>Portsman</a></li>
                <li><a href='/nosmarques#Winston' className='sub-item sub-link'>Winston</a></li>
                <li><a href='/nosmarques#Montecarlo' className='sub-item sub-link'>Monte Carlo</a></li>
                <li><a href='/nosmarques#Camel' className='sub-item sub-link'>Camel</a></li>
              </ul>
            </li>
            <li className={currentPage === '/nosengagements' ? 'current-page item' : 'item'}>
              <a href='/nosengagements' className='nav-link'>{language === 'fr' ? 'NOS ENGAGEMENTS' : 'COMMITMENTS'}</a>
            </li>
            <li className={currentPage === '/nosagences' ? 'current-page item' : 'item'}>
              <a href='/nosagences' className='nav-link'>{language === 'fr' ? 'NOS AGENCES' : 'AGENCIES'}</a>
            </li>
          </ul>
        </div>
      </div>
      <div className='line-nav'>
      </div>
    </div>
  )
}

export default Navbar